export const actionTypes = {
    SCREEN: 'CHANGE_SCREEN',
    SCREEN_B: 'CHANGE_SCREEN_B',
    SCREEN_C: 'CHANGE_SCREEN_C'
}

export const changeScreen = (payload) => ({
    type: actionTypes.SCREEN,
    payload
})

export const changeScreenB = (payload) => ({
    type: actionTypes.SCREEN_B,
    payload
})

export const changeScreenC = (payload) => ({
    type: actionTypes.SCREEN_C,
    payload
})